import name from './name'

const selectSliceData = state => state[name]
const selectOnboardingProfile = state => selectSliceData(state).onboarding
const selectProfilePopoverOpen = state => selectSliceData(state).playlistPopperOpen

export { selectOnboardingProfile, selectProfilePopoverOpen }
